export default __webpack_public_path__ + "static/media/img17.062d7f9d.png";